import * as React from 'react';

import Tag from 'antd/lib/tag';

export const ImplementationFeeWaived = () => (
  <Tag className="implementaion-fee-waived-tag">Implementation Fee Waived</Tag>
);
